import { BKJLoadingSpinner } from '@awais4123/fillify-design-library';
import { Flex } from 'components/Flex';

export const AdministratorSettingsLoadingSpinner = () => {
  return (
    <Flex height="150px">
      <BKJLoadingSpinner variant="Default" />
    </Flex>
  );
};
